import { Divider } from "@mui/material";

import { Theme } from "../../../Style/Theme";

export const HorizontalDivide = ({
  width,
  height,
  marginTop,
  marginBottom,
  color,
  paddingTop,
}) => {
  return (
    <>
      <Divider
        sx={{
          width: width,
          height: height,
          background: color ? color : Theme.palette.background.grayLight05,
          marginTop: marginTop,
          marginBottom: marginBottom,
        }}
        style={{ paddingTop: paddingTop }}
      />
    </>
  );
};
